module.exports = {
	en: {
		'myClan.buttons.editTeam': 'Edit Team',
		'myClan.headers.confirmRoster': 'Confirm your Roster',
		'myClan.headers.createdTeam': 'You have created the Roster!',
		'myClan.headers.youJoined': 'You have joined the Roster!',
		'myClan.messages.howToStartWar':
			'The War will start as soon as you and your opponent have tapped START WAR!',
	},
	fr: {
		'myClan.buttons.editTeam': "Modifier l'équipe",
		'myClan.headers.confirmRoster': 'Confirmer la composition',
		'myClan.headers.createdTeam': "Vous avez créé l'équipe !",
		'myClan.headers.youJoined': "Vous avez rejoint l'équipe !",
		'myClan.messages.howToStartWar':
			'La guerre commencera dès que vous et votre adversaire aurez appuyé sur Déclarer la guerre.',
	},
	it: {
		'myClan.buttons.editTeam': 'Modifica squadra',
		'myClan.headers.confirmRoster': 'Conferma la rosa',
		'myClan.headers.createdTeam': 'Hai completato la creazione della rosa!',
		'myClan.headers.youJoined': 'Ora fai parte della rosa!',
		'myClan.messages.howToStartWar':
			'La guerra avrà inizio non appena tu e l\'avversario avrete premuto "AVVIA GUERRA".',
	},
	de: {
		'myClan.buttons.editTeam': 'Team bearbeiten',
		'myClan.headers.confirmRoster': 'Aufstellung bestätigen',
		'myClan.headers.createdTeam': 'Du hast die Aufstellung erstellt!',
		'myClan.headers.youJoined': 'Du bist der Aufstellung beigetreten!',
		'myClan.messages.howToStartWar':
			'Der Krieg beginnt, sobald du und dein Gegner auf KRIEG STARTEN getippt haben.',
	},
	es: {
		'myClan.buttons.editTeam': 'Editar equipo',
		'myClan.headers.confirmRoster': 'Confirmar plantilla',
		'myClan.headers.createdTeam': '¡Has creado la plantilla!',
		'myClan.headers.youJoined': '¡Te has unido a la plantilla!',
		'myClan.messages.howToStartWar':
			'La guerra empezará en cuanto el equipo rival y tu equipo hayáis tocado «INICIAR GUERRA».',
	},
	pt: {
		'myClan.buttons.editTeam': 'Editar equipe',
		'myClan.headers.confirmRoster': 'Confirmar a escalação',
		'myClan.headers.createdTeam': 'Você criou a escalação!',
		'myClan.headers.youJoined': 'Você entrou na escalação!',
		'myClan.messages.howToStartWar':
			'A guerra começa assim que você e o adversário tiverem tocado no botão INICIAR GUERRA!',
	},
	jp: {
		'myClan.buttons.editTeam': 'チームを編集',
		'myClan.headers.confirmRoster': '登録プレイヤーを確認する',
		'myClan.headers.createdTeam': '登録プレイヤーリストを作成しました！',
		'myClan.headers.youJoined': 'チームに登録されました！',
		'myClan.messages.howToStartWar':
			'両チームが「対戦開始」をタップすると、すぐに対戦が始まります！',
	},
	ko: {
		'myClan.buttons.editTeam': '팀 수정',
		'myClan.headers.confirmRoster': '로스터 확인',
		'myClan.headers.createdTeam': '로스터를 생성했습니다!',
		'myClan.headers.youJoined': '로스터에 합류했습니다!',
		'myClan.messages.howToStartWar':
			'우리 팀과 상대 팀 모두 전쟁 시작을 누르는 즉시 전쟁이 시작됩니다!',
	},
	zh_TW: {
		'myClan.buttons.editTeam': '編輯隊伍',
		'myClan.headers.confirmRoster': '確認隊伍陣容',
		'myClan.headers.createdTeam': '你已創建隊伍陣容！',
		'myClan.headers.youJoined': '你已加入隊伍陣容！',
		'myClan.messages.howToStartWar':
			'你的隊伍和對方隊伍點擊「開始對戰」按鈕後，你們將立即進入對戰！',
	},
}
